import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MasterStore from '@/store/MasterStore';
import AppStore from '@/store/App';

Vue.use(Router)

function isAuthorizedErrorHandler(err: Error) {
    AppStore.showErrorPage("ログイン状態の取得に失敗しました。" + err.message);
}

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    /* Public Zone */
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { public: true },
      async beforeEnter(to, from, next) {
          if(await MasterStore.isAuthorized().catch(isAuthorizedErrorHandler))
              next({ path: '/' })
          else
              next()
      }
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/views/Error.vue'),
      meta: { public: true },
      beforeEnter(to, from, next) {
          if(AppStore.errorMessage)
              next()
          else
              next('/')
      }
    },

    /* Authorized Zone */
    {
      path: '/company',
      component: () => import('@/views/company/CompanyList.vue'),
    },
    {
      path: '/company/:id/dashboard',
      component: () => import('@/views/company/CompanyDashboard.vue'),
      name: 'company_dashboard',
    },
    {
      path: '/company_newinvoice',
      component: () => import('@/views/company/CompanyNewInvoice.vue')
    },
    {
      path: '/company/payments',
      component: () => import('@/views/company/CompanyPayments.vue'),
    },
    {
      path: '/company/rentals',
      component: () => import('@/views/company/RentalConsoles.vue'),
    },
    {
      path: '/conversions',
      component: () => import('@/views/conversion/ConversionDashboard.vue'),
    },
    {
      path: '/conversions/catalog_order',
      component: () => import('@/views/conversion/CatalogOrderList.vue'),
    },
    {
      path: '/conversions/catalog_order/:id',
      component: () => import('@/views/conversion/CatalogOrderDetail.vue'),
      name: 'catalog_order_detail',
    },
    {
      path: '/promo',
      component: () => import('@/views/promo/PromoDashboard.vue'),
    },
    {
      path: '/promo/news',
      component: () => import('@/views/promo/PromoNewsList.vue'),
    },
    {
      path: '/promo/news/:id',
      component: () => import('@/views/promo/PromoNewsDetail.vue'),
      name: 'promo_news_detail',
    },
    {
      path: '*',
      component: () => import('@/views/Preparing.vue'),
    }
  ]
});
// 認証ページ用ルートガード
router.beforeEach(async (to, from ,next) => {
  // 存在しないルートは適切に処理
  if(to.matched.length < 1 || to.matched.length == 1 && to.matched[0].path == '*') {
    if(!await MasterStore.isAuthorized().catch(isAuthorizedErrorHandler)) {
      next({ path: '/login' });
    }
    else {
      next();
    }
  }
  else if(to.matched.some(record => !record.meta.public) && !await MasterStore.isAuthorized().catch(isAuthorizedErrorHandler)) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
  else {
    next();
  }
});

export default router;
